import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useDraggableScroll from "use-draggable-scroll";
import PharmacySubMenuLoader from "../../Components/Loaders/PharmacySubMenuLoader";
import ViewCart from "../../Components/ViewCart";
import { useInfiniteQuery } from "react-query";
import { InStayShopSubMenuAPI } from "../../API/InStayShopAPI";
import InStayShopCartPost from "../../Components/InStayShopCartPost";
import Carosle from "../../Components/Carosle";
import { Button } from "react-bootstrap";

function InStayShopItems() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const lang = sessionStorage.getItem("lang");

  const [selected, setSelected] = useState(params.cat_id);

  const ref = useRef(null);
  const shopItemsRef = useRef(null);
  const { onMouseDown } = useDraggableScroll(ref);

  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useInfiniteQuery(
      `InStayShopSubMenu-${lang}-${selected}`,
      ({ pageParam = 1 }) =>
        InStayShopSubMenuAPI({
          room_uuid,
          selected,
          pageParam,
          lang,
        }),
      {
        getNextPageParam: (pageData) => {
          const lastPage = pageData.data?.data?.items?.pagination?.last_page;
          const currentPage =
            pageData.data?.data?.items?.pagination?.current_page;
          return currentPage < lastPage ? currentPage + 1 : undefined;
        },
      }
    );

  let title;
  let headerImages;

  if (!isLoading) {
    if (data?.pages[0].data.status === false) {
      navigate(`/${room_uuid}/qr-scan`);
    } else {
      title = data?.pages[0]?.data?.data?.title.replace("In Stay", "In-Stay");
      headerImages = data?.pages[0]?.data?.data?.banners;
    }
  }

  const loadMoreRef = useRef();

  useEffect(() => {
    if (!hasNextPage) return;
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => entry.isIntersecting && fetchNextPage()),
      { root: null, margin: "0px", threshold: 1.0 }
    );
    const el = loadMoreRef && loadMoreRef.current;
    if (!el) return;
    observer.observe(el);
  }, [loadMoreRef.current, hasNextPage]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  useEffect(() => {
    if (ref.current) {
      const lists = ref.current.children;
      Object.values(lists).map((list, idx) => {
        if (list.classList.contains("active")) {
          ref.current.scrollTo({
            left: idx * list.offsetWidth,
            behavior: "smooth",
          });
        }
      });
    }
  }, [data]);

  const devRef = useRef(null);
  useLayoutEffect(() => {
    if (devRef.current) {
      if (data?.pages[0].data?.data?.items?.data.length > 4) {
        const divAnimate = devRef.current.getBoundingClientRect().top - 70;
        const heightDiv = devRef.current.getBoundingClientRect().height;
        const onScroll = () => {
          if (divAnimate < window.scrollY) {
            devRef.current.classList.add("fixedSearch");
            shopItemsRef.current.style.paddingTop = `${Math.floor(
              heightDiv
            )}px`;
          } else {
            devRef.current.classList.remove("fixedSearch");
            shopItemsRef.current.style.paddingTop = "0px";
          }
        };
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
      }
    }
  }, [data]);

  return (
    <>
      <HeaderInner headerName={title} />
      <main className="bg-white pad-top-0" style={{ marginBottom: "100px" }}>
        {isLoading ? (
          <PharmacySubMenuLoader />
        ) : (
          <>
            {headerImages?.length > 0 && (
              <header className="img-header m-0">
                <Carosle headerImages={headerImages} />
              </header>
            )}

            <div ref={devRef}>
              <ul
                className="inline-list search"
                ref={ref}
                onMouseDown={onMouseDown}
              >
                {data?.pages[0]?.data?.data?.categories?.map((cat, idx) => (
                  <li
                    key={idx}
                    className={selected == cat.id ? "active" : ""}
                    onMouseDown={() => {
                      setSelected(cat.id);
                      window.scrollTo({ top: 0, left: 0 });
                    }}
                  >
                    <Button>{cat?.name}</Button>
                  </li>
                ))}
              </ul>
            </div>

            <div ref={shopItemsRef}>
              {data?.pages?.map((page) =>
                page?.data?.data?.items?.data?.map((item) => (
                  <div key={item.id} className="add-post-container add-cart">
                    <InStayShopCartPost
                      item={item}
                      canOrder={page.data?.data?.can_order}
                    />
                  </div>
                ))
              )}

              <div
                className="ref_loading"
                ref={loadMoreRef}
                onClick={() => fetchNextPage()}
                disabled={!hasNextPage || isFetchingNextPage}
              ></div>
              {(isFetchingNextPage || hasNextPage) && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden"></span>
                  </div>
                </div>
              )}
            </div>

            <ViewCart room_uuid={room_uuid} />
          </>
        )}
      </main>
    </>
  );
}

export default InStayShopItems;
